// eslint-disable-next-line max-len
const FAQ_QUESTIONS_KEYS = ['quickQuote', 'information', 'assumption', 'wrongAssumptions', 'changeEstimatedPrice', 'fullQuote', 'priceGuaranteed', 'isSaved', 'notRenewal'];

const wsReferrers = () => {
    const result = [];
    for (let i = 1; i <= 22; i += 1) {
        if (i <= 9) {
            result.push(`https://ws0${i}.sid.internal.saga.co.uk/insurance/car-insurance/get-quote/html/`);
            result.push(`https://ws0${i}.sid.internal.saga.co.uk/insurance/home-insurance/get-quote/html/`);
            result.push(`https://ws0${i}.sid.internal.saga.co.uk/insurance/quick-quote/get-quote/html/`);
        } else {
            result.push(`https://ws${i}.sid.internal.saga.co.uk/insurance/car-insurance/get-quote/html/`);
            result.push(`https://ws${i}.sid.internal.saga.co.uk/insurance/home-insurance/get-quote/html/`);
            result.push(`https://ws${i}.sid.internal.saga.co.uk/insurance/quick-quote/get-quote/html/`);
        }
    }
    return result;
};

const WHIITELISTED_REFERRERS = {
    NON_LOCAL: [
        'https://www.saga.co.uk/insurance/car-insurance/get-quote/html/',
        'https://www.saga.co.uk/insurance/home-insurance/get-quote/html/',
        'https://www.saga.co.uk/insurance/quick-quote/get-quote/html/',
        'https://dev1.web.saga.co.uk/mysaga/Default.aspx',
        'https://uat3.web.saga.co.uk/mysaga/Default.aspx',
        'https://uat9.web.saga.co.uk/mysaga/Default.aspx',
        'https://www.saga.co.uk/mysaga/Default.aspx',
        'https://preprod.saga.co.uk/mysaga/Default.aspx',
        ...wsReferrers()
    ],
    LOCAL: [
        'http://localhost:3001/',
        'http://localhost:3002/',
        'http://localhost:3005/',
        'https://localhost:44384/mysaga/Default.aspx'
    ]
};

export default {
    FAQ_QUESTIONS_KEYS,
    WHIITELISTED_REFERRERS
};
